import React from 'react'
import httpClient from './myapi';

const WebSever = httpClient.WebSever+'/features/';
const CardFeature = ({ img, title }) => (
    <div className="mycard">
        <img src={WebSever+img} alt='1' height={190}/>
        <div className="feature-title">
            {title}
        </div>
    </div>
)
export default CardFeature;